<header class="MainNavigation" id="MainNavigation">
  <div class="Wrap Wrap">
    <!-- LOGO CULLEN -->
    <a *ngIf="isGenesisContext" class="LogoCullen" href="/client/site" [ngClass]="mobileSearchIsShow ? 'LogoCullen--hide' : ''">
      <img src="assets/images/logo-cullen-horizontal.png" alt="Cullen International">
    </a>
    <a *ngIf="!isGenesisContext" class="LogoCullen" [routerLink]="['/site']" [ngClass]="mobileSearchIsShow ? 'LogoCullen--hide' : ''">
      <img src="assets/images/logo-cullen-horizontal.png" alt="Cullen International">
    </a>
    <!-- MOBILE SEARCH -->
    <icullen-search-bar *ngIf="mobileSearchIsShow" [isMobile]="true"></icullen-search-bar>
    <!-- CENTRAL MENU -->
    <nav appNavClickTrack menuType="Primary">
      <ul>
        <li class="Menu" *ngIf="isGenesisContext">
          <a href="/client/site" [class.Active]="activeLink==='my-cullen'" [attr.level1]="'Home'">Home</a>
          <ul class="Submenu" *ngIf="menuItems && menuItems.categories">
            <li *ngFor="let category of menuItems.categories">
              <ng-container *ngIf="category.subCategories?.length === 0 ">
                <a href="/client/site/headlines/service/{{category.name}}" [attr.level1]="'Home'" [attr.level2]="('uishared.services.'+category.name) | transloco">{{('uishared.services.'+category.name) | transloco}}</a>
              </ng-container>
              <ng-container *ngIf="category.subCategories?.length>0">
                <a>{{('uishared.services.parent.'+category.name) | transloco}}</a>
                <ul class="Subsubmenu">
                  <li *ngFor="let subcategory of category.subCategories">
                    <a href="/client/site/headlines/service/{{subcategory.name}}" [attr.level1]="'Home'" [attr.level2]="('uishared.services.'+subcategory.name) | transloco">{{('uishared.services.'+subcategory.name) | transloco}}</a>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </li>
        <li class="Menu" *ngIf="!isGenesisContext">
          <a [routerLink]="['/site']" routerLinkActive="Active" [routerLinkActiveOptions]="{exact: true}" [class.Active]="activeLink==='my-cullen'" [attr.level1]="'Home'">Home</a>
          <ul class="Submenu" *ngIf="menuItems && menuItems.categories">
            <li *ngFor="let category of menuItems.categories">
              <ng-container *ngIf="category.subCategories?.length === 0 ">
                <a [routerLink]="'/site/headlines/service/' + category.name" [attr.level1]="'Home'" [attr.level2]="('uishared.services.'+category.name) | transloco">{{('uishared.services.'+category.name) | transloco}}</a>
              </ng-container>
              <ng-container *ngIf="category.subCategories?.length>0">
                <a>{{('uishared.services.parent.'+category.name) | transloco}}</a>
                <ul class="Subsubmenu">
                  <li *ngFor="let subcategory of category.subCategories">
                    <a [routerLink]="'/site/headlines/service/' + subcategory.name" [attr.level1]="'Home'" [attr.level2]="('uishared.services.'+subcategory.name) | transloco">{{('uishared.services.'+subcategory.name) | transloco}}</a>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </li>
        <!-- <li class="Menu">
          <span>Applications</span>
          <ul class="Submenu" *ngIf="menuItems && menuItems.applications">
            <li *ngFor="let app of menuItems.applications">
              <a href="{{getAppNavUrl(app)}}" *ngIf="!app?.docApp" target="secondaryTab" [attr.level1]="'Applications'" [attr.level2]="('uishared.apps.'+app.name) | transloco">{{ ('uishared.apps.'+app.name) | transloco }}</a>
              <a *ngIf="isGenesisContext && app.docApp" href="{{getAppNavUrl(app)}}" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'Applications'" [attr.level2]="app.name">
                {{ app.name }}
              </a>
              <a *ngIf="!isGenesisContext && app.docApp" [routerLink]="'/site/documents/' + app.uniquenumber" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'Applications'" [attr.level2]="app.name">
                {{ app.name }}
              </a>
            </li>
            <ng-container *ngFor="let cat of menuItems.categories">
              <ng-container *ngIf="cat.name === 'Competition_Law'">
                <li *ngFor="let subcat of cat.subCategories">
                  <a *ngIf="subcat.name === 'Competition_Law'" (click)="closeMobileMenuOnClick()" [routerLink]="'/site/case-database/COMPETITION_LAW_DOC'" [attr.level1]="'Applications'" [attr.level2]="('uishared.apps.'+subcat.name) | transloco">
                    {{('uishared.apps.'+subcat.name) | transloco}}
                  </a>
                  <a *ngIf="subcat.name === 'state_aid'" (click)="closeMobileMenuOnClick()" [routerLink]="'/site/case-database/STATE_AID'" [attr.level1]="'Applications'" [attr.level2]="('uishared.apps.'+subcat.name) | transloco">
                    {{('uishared.apps.'+subcat.name) | transloco}}
                  </a>
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </li> -->
        <li class="Menu" id="MyFeedStep1" *ngIf="isGenesisContext">
          <a href="/site/my-cullen/" [class.Active]="activeLink==='myCullen'" [attr.level1]="'myCullen'" *ngIf="featureFlagService.isTopicsContainerEnabled()">My Feed</a>
        </li>
        <li class="Menu" id="MyFeedStep1" *ngIf="!isGenesisContext">
          <a [routerLink]="['/site/my-cullen']" routerLinkActive="Active" [class.Active]="activeLink==='myCullen'" [attr.level1]="'myCullen'" *ngIf="featureFlagService.isTopicsContainerEnabled()">My Feed</a>
        </li>
        <li class="Menu" id="HomeStep4" *ngIf="isGenesisContext">
          <a href="/site/toolbox/" [class.Active]="activeLink==='toolbox'" [attr.level1]="'Toolbox'">Toolbox</a>
        </li>
        <li class="Menu" id="HomeStep4" *ngIf="!isGenesisContext">
          <a [routerLink]="['/site/toolbox']" routerLinkActive="Active" [class.Active]="activeLink==='toolbox'" [attr.level1]="'Toolbox'">Toolbox</a>
        </li>
        <li class="Menu" *ngIf="isGenesisContext">
          <a href="/client/trainings/" [class.Active]="activeLink==='trainings'" [attr.level1]="'Training'">Training</a>
        </li>
        <li class="Menu" *ngIf="!isGenesisContext">
          <a [routerLink]="['/trainings/']" routerLinkActive="Active" [class.Active]="activeLink==='trainings'" [attr.level1]="'Training'">Training</a>
        </li>
        <li class="Menu">
          <span>About</span>
          <ul class="Submenu">
            <li>
              <a href="/" target="secondaryTab" [attr.level1]="'About'" [attr.level2]="'Cullen International'">Cullen International</a>
            </li>
            <li>
              <a href="/subscription.html#expertise" target="secondaryTab" [attr.level1]="'About'" [attr.level2]="'Subscription services'">Subscription services</a>
            </li>
            <li>
              <a href="/studies.html" target="secondaryTab" [attr.level1]="'About'" [attr.level2]="'Studies'">Studies</a>
            </li>
            <li>
              <a href="/events.html" target="secondaryTab" [attr.level1]="'About'" [attr.level2]="'Events'">Events calendar</a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <img *ngIf="currentUser?.connectedAsCustomer" class="SeeAsCustomerBanner" src="assets/images/see_as_customer.png" alt="See as customer">
    <!-- NEW RIGHT ICONS DESKTOP -->
    <div class="Icons-desktop-new">
      <ul>
        <!-- NOTIFICATIONS DESKTOP BUTON -->
        <li class="Icon Icon--notifications" id="MyFeedStep7" *ngIf="featureFlagService.isTopicsContainerEnabled()">
          <span class="ClickZone" (click)="seeNotificationsOnClick()"></span>
          <span class="Count" *ngIf="unseenNotificationsCount > 0">{{ unseenNotificationsCount }}</span>
          <div class="Notifications" *ngIf="notifications && showNotifications">
            <div class="Notification-header">
              <h4>Notifications</h4>
              <div class="CloseNotifications" (click)="closeNotificationsOnClick()"></div>
            </div>
            <ul class="Notification-list">
              <li *ngFor="let notification of notifications.notifications">
                <a [routerLink]="['/site/documents', notification.documentUniqueNumber]" [fragment]="notification.sectionUuid">
                  <h5>{{ notification.title }}</h5>
                  <span class="Metadatas">{{ notification.publicationDate | date }} | {{('siteviewer.groupedDocTypes.' + notification.contentType) | transloco}}</span>
                </a>
              </li>
            </ul>
            <div class="Notification-footer">
              <a class="Button" [routerLink]="['/site/my-cullen']" [queryParams]="{view: 'list'}" (click)="closeNotificationsOnClick()">View all publications</a>
            </div>
          </div>
        </li><!--
     --><li class="Icon Icon--favorites" id="FavoritessStep1" matTooltip="Favorites" matTooltipPosition="below">
          <a [routerLink]="['/site/favorites']">
            <span class="Count">{{(favDocs$ | async)?.length}}</span>
          </a>
        </li><!--
     --><li class="Icon Icon--emailAlerts" id="NotificationsStep1" matTooltip="Manage e-mail alerts" matTooltipPosition="below">
          <a [routerLink]="['/site/settings/alerts']">
            <span class="Link">S</span>
          </a>
        </li><!--
     --><li class="Icon Icon--help" id="WelcomeStep2" matTooltip="Help Center" matTooltipPosition="below">
          <a [routerLink]="['/site/help']">
            <span class="Link" >H</span>
          </a>
        </li><!--
     --><li class="Icon Icon--profil">
          <div class="Submenu" *ngIf="currentUser && !currentUser?.partialAuth">
            <h2>{{currentUser?.given_name}} {{currentUser?.family_name}}</h2>
            <ul>
              <li>
                <a [routerLink]="['/site/settings']">Settings</a>
              </li>
              <li>
                <a (click)="logout()">Sign out</a>
              </li>
            </ul>
          </div>
          <div class="Submenu" *ngIf="!currentUser || currentUser?.partialAuth">
            <img src="assets/images/logo-cullen-rounded.png" alt="Cullen International">
            <ul>
              <li>
                <a (click)="login()">Login</a>
              </li>
              <li *ngIf="isGenesisContext">
                <a href="/client/site/help">Help</a>
              </li>
              <li *ngIf="!isGenesisContext">
                <a [routerLink]="['/site/help']">Help</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <!-- END NEW RIGHT ICONS DESKTOP -->
    <!-- RIGHT ICONS MOBILE-->
    <div class="Icons-mobile">
      <div class="Search" [ngClass]="mobileSearchIsShow ? 'Search--active' : ''" id="HomeMobileStep3" >
        <div class="Magnifier" (click)="showMobileSearchOnClick()" data-cy="openSearchBarOnMobile"></div>
        <div class="Close" (click)="hideMobileSearchOnClick()"></div>
      </div><!-- NOTIFICATIONS MOBILE BUTON
   --><div class="Notifications" (click)="openMobileNotificationsOnClick()" *ngIf="notifications && showNotifications">
        <span class="Count" *ngIf="unseenNotificationsCount > 0">{{ unseenNotificationsCount }}</span>
      </div><!--
   --><div class="Profile" (click)="openMobileProfileOnClick()" id="NotificationsMobileStep1"></div><!--
   --><div class="Menu" (click)="openMobileMenuOnClick()" id="HomeMobileStep1"></div>
      <!-- MOBILE BLACK OVERLAY -->
      <div class="BlackOverlay" (click)="closeMobileMenuOnClick()" (click)="closeMobileProfileOnClick()" [ngClass]="mobileMenuIsOpen || mobileProfileIsOpen || mobileNotificationsIsOpen ? 'BlackOverlay--active' : ''"></div>
      <!-- MOBILE NOTIFICATIONS MENU -->
      <div class="Notifications-isOpen" [ngClass]="mobileNotificationsIsOpen ? 'Notifications-isOpen--active' : ''" *ngIf="notifications && showNotifications">
        <header>
          <h4>Notifications</h4>
          <div class="CloseNotifications" (click)="closeMobileNotificationsOnClick()"></div>
        </header>
        <ul class="Notification-list">
          <li *ngFor="let notification of notifications.notifications">
            <a href="#" [ngClass]="('siteviewer.groupedDocTypes.' + notification.contentType) | transloco">
              <h5>{{ notification.title }}</h5>
              <span class="Metadatas">{{ notification.publicationDate | date }} | {{('siteviewer.groupedDocTypes.' + notification.contentType) | transloco}}</span>
            </a>
          </li>
        </ul>
        <footer>
          <a [routerLink]="['/site/my-cullen']" class="Button" [queryParams]="{view: 'list'}" (click)="closeMobileNotificationsOnClick()">View all publications</a>
        </footer>
      </div>
      <!-- MOBILE PROFILE MENU -->
      <div class="Profile-isOpen" [ngClass]="mobileProfileIsOpen ? 'Profile-isOpen--active' : ''">
        <header>
          <ul class="SocialMenu">
            <li class="Social Social--twitter"><a href="https://twitter.com/CullenInt/" target="secondaryTab"></a></li><!--
         --><li class="Social Social--linkedin"><a href="https://www.linkedin.com/company/cullen-international/" target="secondaryTab"></a></li>
          </ul>
          <div class="CloseProfile" (click)="closeMobileProfileOnClick()"></div>
          <div class="MyCullen">
            <img class="RoundedLogoCullen" src="assets/images/logo-cullen-rounded.png" alt="Cullen International">
            <h2 *ngIf="!currentUser?.partialAuth">{{currentUser?.given_name}} {{currentUser?.family_name}}</h2>
          </div>
        </header>
        <ul class="Navigation" *ngIf="currentUser && !currentUser?.partialAuth">
          <li>
            <a [routerLink]="['/site/favorites']" (click)="closeMobileProfileOnClick()">Favorites: <span>{{(favDocs$ | async)?.length}}</span></a>
          </li>
          <li>
            <a [routerLink]="['/site/settings']" (click)="closeMobileProfileOnClick()">Settings</a>
          </li>
          <li *ngIf="isGenesisContext" class="Navigation-secondary">
            <a href="/cient/site/settings/alerts" (click)="closeMobileProfileOnClick()">Manage e-mail alerts</a>
          </li>
          <li *ngIf="!isGenesisContext" class="Navigation-secondary">
            <a [routerLink]="['/site/settings/alerts']" (click)="closeMobileProfileOnClick()">Manage e-mail alerts</a>
          </li>
          <li *ngIf="isGenesisContext" class="Navigation-secondary">
            <a href="/client/site/settings/details" (click)="closeMobileProfileOnClick()">Change password</a>
          </li>
          <li *ngIf="!isGenesisContext" class="Navigation-secondary">
            <a [routerLink]="['/site/settings/details']" (click)="closeMobileProfileOnClick()">Change password</a>
          </li>
          <li *ngIf="!isGenesisContext">
            <a [routerLink]="['/site/help']" (click)="closeMobileProfileOnClick()">Help Center</a>
          </li>
          <li>
            <a (click)="logout()">Sign out</a>
          </li>
        </ul>
        <ul class="Navigation" *ngIf="!currentUser || currentUser?.partialAuth">
          <li>
            <a (click)="login()">Login</a>
          </li>
          <li *ngIf="isGenesisContext">
            <a href="/client/site/help">Help</a>
          </li>
          <li *ngIf="!isGenesisContext">
            <a [routerLink]="['/site/help']">Help</a>
          </li>
        </ul>
      </div>
      <!-- MOBILE NAVIGATION MENU -->
      <div class="Menu-isOpen" [ngClass]="mobileMenuIsOpen ? 'Menu-isOpen--active' : ''">
        <header>
          <div class="CloseMenu" (click)="closeMobileMenuOnClick()"></div>
        </header>
        <ul class="Navigation" appNavClickTrack menuType="Primary">
          <li *ngIf="isGenesisContext">
            <a href="/client/site" [class.Active]="activeLink==='my-cullen'" [attr.level1]="'Home'">{{ 'uishared.home' | transloco }}</a>
            <ul class="Submenu" *ngIf="menuItems && menuItems.categories">
              <li *ngFor="let category of menuItems.categories">
                <ng-container *ngIf="category.subCategories?.length === 0 ">
                  <a href="/client/site/headlines/service/{{category.name}}" [attr.level1]="'Home'" [attr.level2]="('uishared.services.'+category.name) | transloco">{{('uishared.services.'+category.name) | transloco}}</a>
                </ng-container>
                <ng-container *ngIf="category.subCategories?.length>0">
                  <ul class="Subsubmenu">
                    <li *ngFor="let subcategory of category.subCategories">
                      <a href="/client/site/headlines/service/{{subcategory.name}}" (click)="closeMobileMenuOnClick()" [attr.level1]="'Home'" [attr.level2]="('uishared.services.'+subcategory.name) | transloco">
                        {{('uishared.services.parent.'+category.name) | transloco}} - {{('uishared.services.'+subcategory.name) | transloco}}
                      </a>
                    </li>
                  </ul>
                </ng-container>
              </li>
            </ul>
          </li>
          <li *ngIf="!isGenesisContext">
            <a [routerLink]="['/site']" routerLinkActive="Active" [routerLinkActiveOptions]="{exact: true}" [class.Active]="activeLink==='my-cullen'" (click)="closeMobileMenuOnClick()" [attr.level1]="'Home'">{{ 'uishared.home' | transloco }}</a>
            <ul class="Submenu" *ngIf="menuItems && menuItems.categories">
              <li *ngFor="let category of menuItems.categories">
                <ng-container *ngIf="category.subCategories?.length === 0 ">
                  <a [routerLink]="'/site/headlines/service/' + category.name" (click)="closeMobileMenuOnClick()" [attr.level1]="'Home'" [attr.level2]="('uishared.services.'+category.name) | transloco">{{('uishared.services.'+category.name) | transloco}}</a>
                </ng-container>
                <ng-container *ngIf="category.subCategories?.length>0">
                  <ul class="Subsubmenu">
                    <li *ngFor="let subcategory of category.subCategories">
                      <a [routerLink]="'/site/headlines/service/' + subcategory.name" (click)="closeMobileMenuOnClick()" [attr.level1]="'Home'" [attr.level2]="('uishared.services.'+subcategory.name) | transloco">
                        {{('uishared.services.parent.'+category.name) | transloco}} - {{('uishared.services.'+subcategory.name) | transloco}}
                      </a>
                    </li>
                  </ul>
                </ng-container>
              </li>
            </ul>
          </li>
          <!-- <li>
            <span>Applications</span>
            <ul *ngIf="menuItems && menuItems.applications">
              <li *ngFor="let app of menuItems.applications">
                  <a href="{{getAppNavUrl(app)}}" *ngIf="!app?.docApp" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'Applications'" [attr.level2]="('uishared.apps.'+app.name) | transloco">{{ ('uishared.apps.'+app.name) | transloco }}</a>
                  <a *ngIf="isGenesisContext && app.docApp" href="{{getAppNavUrl(app)}}" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'Applications'" [attr.level2]="app.name">
                    {{ app.name }}
                  </a>
                  <a *ngIf="!isGenesisContext && app.docApp" [routerLink]="'/site/documents/' + app.uniquenumber" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'Applications'" [attr.level2]="app.name">
                    {{ app.name }}
                  </a>
              </li>
              <ng-container *ngFor="let cat of menuItems.categories">
                <ng-container *ngIf="cat.name === 'Competition_Law'">
                  <li *ngFor="let subcat of cat.subCategories">
                    <a *ngIf="subcat.name === 'Competition_Law'" (click)="closeMobileMenuOnClick()" [routerLink]="'/site/case-database/COMPETITION_LAW_DOC'" [attr.level1]="'Applications'" [attr.level2]="('uishared.apps.'+subcat.name) | transloco">
                      {{('uishared.apps.'+subcat.name) | transloco}}
                    </a>
                    <a *ngIf="subcat.name === 'state_aid'" (click)="closeMobileMenuOnClick()" [routerLink]="'/site/case-database/STATE_AID'" [attr.level1]="'Applications'" [attr.level2]="('uishared.apps.'+subcat.name) | transloco">
                      {{('uishared.apps.'+subcat.name) | transloco}}
                    </a>
                  </li>
                </ng-container>
              </ng-container>
            </ul>
          </li> -->
          <li *ngIf="isGenesisContext">
            <a href="/site/my-cullen/" [class.Active]="activeLink==='myCullen'" [attr.level1]="'myCullen'" *ngIf="featureFlagService.isTopicsContainerEnabled()">My Feed</a>
          </li>
          <li *ngIf="!isGenesisContext">
            <a [routerLink]="['/site/my-cullen']" routerLinkActive="Active" [class.Active]="activeLink==='myCullen'" [attr.level1]="'myCullen'" *ngIf="featureFlagService.isTopicsContainerEnabled()">My Feed</a>
          </li>
          <li *ngIf="isGenesisContext">
            <a href="/site/toolbox/" [class.Active]="activeLink==='toolbox'" [attr.level1]="'Toolbox'">Toolbox</a>
          </li>
          <li  *ngIf="!isGenesisContext">
            <a [routerLink]="['/site/toolbox']" routerLinkActive="Active" [class.Active]="activeLink==='toolbox'" [attr.level1]="'Toolbox'">Toolbox</a>
          </li>
          <li *ngIf="isGenesisContext">
            <a href="/client/trainings/" [class.Active]="activeLink==='trainings'" [attr.level1]="'Training'">Training</a>
          </li>
          <li  *ngIf="!isGenesisContext">
            <a [routerLink]="['/trainings/']" routerLinkActive="Active" [class.Active]="activeLink==='trainings'" [attr.level1]="'Training'">Training</a>
          </li>
          <li>
            <a href="https://www.cullen-international.com/" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'About'">About</a>
            <ul class="Submenu">
              <li>
                <a href="/" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'About'" [attr.level2]="'Cullen International'">Cullen International</a>
              </li>
              <li>
                <a href="/subscription.html#expertise" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'About'" [attr.level2]="'Subscription services'">Subscription services</a>
              </li>
              <li>
                <a href="/studies.html" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'About'" [attr.level2]="'Studies'">Studies</a>
              </li>
              <li>
                <a href="/conferences.html" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'About'" [attr.level2]="'Conferences & Seminars'">Conferences & Seminars</a>
              </li>
              <li>
                <a href="/events.html" target="_blank" (click)="closeMobileMenuOnClick()" [attr.level1]="'About'" [attr.level2]="'Events'">Events calendar</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
